import fullLogo from '../../assets/images/fullLogo.svg';
import Advantages from './promo/advantages.tsx';

function promo() {
  return (
    <div className='promo'>
      <div className='promo__container'>
        <div className='promo__info'>
          <img className='promo__info-img' src={fullLogo} alt="Aqua time spa massage" />
          <p className='promo__info-text'>В Aqua Time похудение с удовольствием и заботой о себе: от 4-6 кг за месяц без диет, боли и изнурительных тренировок.</p>
          <a href='https://n1386588.yclients.com' className='promo__info-button'>ЗАПИСЬ НА МАССАЖ</a>
          <div className='promo__info-signature'>Запишись на пробное посещение со скидкой -20%.</div>
        </div>
        <div className='promo__advantages'>
          <Advantages />
        </div>
      </div>
    </div>
   );
}

export default promo;